module.exports = __webpack_public_path__ + "img/20210307-66.d596e488.jpg";